/**
 * OverlayCanvas (JSX)
 * -------------------
 * A transparent SVG that sits above the chart and receives pointer input.
 * Pass your handlers (pointerdown/move/up) directly; we set the right defaults.
 *
 * Props:
 *  - overlay: { w, h }
 *  - children: SVG content (guides, live stroke, etc.)
 */

import React from "react";

export default function OverlayCanvas({
  overlay,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  children,
}) {
  const w = overlay?.w ?? 0;
  const h = overlay?.h ?? 0;

  return (
    <svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      style={{
        position: "absolute",
        inset: 0,
        width: "100%",
        height: h,
        zIndex: 10,
        pointerEvents: "auto",
        touchAction: "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        cursor: "crosshair",
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerUp}
      onContextMenu={(e) => e.preventDefault()}
      role="img"
      aria-label="Chart interaction overlay"
    >
      {children}
    </svg>
  );
}
